<template>
  <v-row>
    <v-col class="d-block pt-0" cols="12">
      <div v-if="migrations.length > 1">
        <v-alert
          type="warning"
          color="error lighten-1"
          class="py-3 px-1 mb-3"
          role="note"
        >
          <template v-slot:prepend>
            <v-icon class="mx-2 d-none d-sm-block white--text">mdi-alert-circle-outline</v-icon>
          </template>
          <template>
            <div class="hidden-xs-only">
              <div class="d-flex justify-space-between align-center">
                You have multiple migrations scheduled for your services.
                <gg-btn color="error" class="flex-shrink mr-2" :to="{ name: 'migrations' }" role="link">
                  View Migrations
                </gg-btn>
              </div>
            </div>
          </template>
        </v-alert>
      </div>
      <div v-else>
        <v-alert
          v-for="migration in migrations"
          type="warning"
          color="error lighten-1"
          class="py-3 px-1 mb-3"
          role="note"
          :key="`ma-${migration.id}`"
        >
        <template v-slot:prepend>
          <v-icon class="mx-2 d-none d-sm-block white--text">mdi-alert-circle-outline</v-icon>
        </template>
        <template>
          <div class="hidden-xs-only">
            <div class="d-flex justify-space-between align-center">
              {{ migration.service_name }} has a migration scheduled.
              This banner will go away once the migration is completed.
              <gg-btn color="error" class="flex-shrink mr-2" :to="{ name: 'migration_details', params: { id: migration.id } }" role="link">
                View
              </gg-btn>
            </div>
          </div>
        </template>
        <template v-slot:append>
          <v-btn icon class="mr-2" @click="hideAlert(migration.id)">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </template>
      </v-alert>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'MigrationsAlert',
  props: {
    migrations: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions({
      hideMigrationAlert: 'migrations/hideMigrationAlert'
    }),
    hideAlert (migrationId) {
      this.hideMigrationAlert(migrationId)
    }
  },
}
</script>
